import type {
  TerminalResponse,
  CertificateResponse,
  AuthConfig,
  LoginResponse,
  SignDataFunction,
  ClientResponse,
} from '../../types'
import { UYAPAuthenticator } from '@takibet/shared/src/UYAPAuthenticator'

const authenticator = new UYAPAuthenticator(
  {
    initializeURL: `/web.uyap`,
    finalizeURL: `/web.uyap`,
    loginURL: `/login.uyap`,
    checkUserURL: `/kullanici_bilgileri.uyap`,
  },
  () => {},
  () => {},
)

export class UyapAuthenticator {
  constructor(
    private readonly config: AuthConfig,
    private readonly signData: SignDataFunction,
  ) {}

  /**
   * Login işlemini gerçekleştirir
   * @param pinCode - Kullanıcı PIN kodu
   * @param terminal - Terminal bilgileri
   * @param certificate - Sertifika bilgileri
   * @returns Login işlemi sonucu
   */
  async login({
    client,
    terminal,
    certificate,
    pinCode,
  }: {
    client: ClientResponse
    terminal: TerminalResponse
    certificate: CertificateResponse
    pinCode: string
  }): Promise<LoginResponse> {
    const initResponse = await authenticator.initializeLogin(
      certificate.certificate,
    )

    if (!initResponse.success) {
      throw new Error('İmzalama işlemi sırasında hata oluştu!')
    }

    const { digestBase64: dataToSign, transactionUUID } = initResponse

    // 2. Veriyi imzala
    const response = await this.signData({
      client,
      certificate: { cert: certificate, terminal: terminal, },
      dataToSign,
      pinCode,
    })

    const {
      signature: [{ signature }],
    } = response

    if (!signature) {
      throw new Error('İmzalama sırasında bir sorun ile karşılaşılmıştır.')
    }

    // 3. İmzalamayı tamamla
    const finalizeResponse = await authenticator.finalizeLogin(
      {
        signatureBase64: signature,
        transactionUUID,
        certificateCommonName: certificate.commonName
      },
    )

    if (!finalizeResponse.success) {
      throw new Error('İmzalama sırasında bir sorun ile karşılaşılmıştır.')
    }

    // 4. Login işlemini tamamla
    try {
      await authenticator.loginSetCookieRequest()
    } catch (e) {
      console.error(
        'Giriş sırasında hata oluştu, ancak işleme devam edilebilir',
        e,
      )
    }

    return { success: true, message: 'Giriş başarılı' }
  }

  /**
   * UTF-8 string'i Base64'e çevirir
   * @param str - Çevrilecek string
   * @returns Base64 formatında string
   */
  private base64EncodeUTF8(str: string): string {
    let binary = ''

    const utf8Bytes = new TextEncoder().encode(str)
    for (let byte of utf8Bytes) binary += String.fromCharCode(byte)

    return btoa(binary)
  }
}
